import { Text } from 'react-native';

import DrawerPage from 'components/layout/drawer-page';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useWalmartDisabledPage = () => {
  const enableWalmartPlusIntegration = useFlag(LaunchDarklyFlag.ENABLE_WALMART_PLUS_INTEGRATION);
  if (!enableWalmartPlusIntegration) {
    // TODO localize, this isn't a thing on CA and its a OTA hotfix so quick for now.
    return (
      <DrawerPage headerText="Walmart+ Not Available" dismissType="close">
        <Text>
          We're sorry, the Walmart+ link isn't currently available. Please try again later.
        </Text>
      </DrawerPage>
    );
  }
  return null;
};
